/**
 * Recommended role of a place in a walking route.
 * Stored values stay stable. Product labels:
 * anchor = must-see, primary = highlight, optional = supporting,
 * detour = side trip, connector = a named stop that links the walk.
 * A silent map vertex is `ReadyRouteStopKind.waypoint`, not this enum.
 * A route may override the recommendation on the stop.
 */
export enum AttractionRouteRoleEnum {
    ANCHOR = 'anchor',
    PRIMARY = 'primary',
    CONNECTOR = 'connector',
    OPTIONAL = 'optional',
    DETOUR = 'detour',
}
